import { LoadingButton } from "@mui/lab";
import { Alert, Box, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  clearCabinState,
  createCabinThunk,
  updateCabinThunk,
} from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  number: yup.number().required("Please enter cabin number").positive().min(1),
});
const CreateUpdateCabin = ({ m_id, number, cabin }) => {
  const formik = useFormik({
    initialValues: {
      number: cabin ? cabin.number : number ?? 1,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const _data = { ...data, machine: m_id };
      //   console.log(_data);
      if (cabin) {
        dispatch(updateCabinThunk({ id: cabin.id, data: _data }));
      } else {
        dispatch(createCabinThunk(_data));
      }
    },
  });
  const vendingState = useSelector((state) => state.vending);

  useEffect(() => {
    dispatch(clearCabinState());
  }, []);
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label="Enter cabin number"
          variant="outlined"
          name="number"
          type="number"
          fullWidth
          sx={{ mt: 1 }}
          value={formik.values.number}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.number)}
          helperText={formik.errors.number}
          autoComplete="new-password"
          required
        />
        {(vendingState.updateCabinError || vendingState.createCabinError) && (
          <Alert sx={{ mt: 1 }} severity="error">
            Error occurred
          </Alert>
        )}
        {(vendingState.updateCabinSuccess ||
          vendingState.createCabinSuccess) && (
          <Alert sx={{ mt: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={
            vendingState.createCabinLoading || vendingState.updateCabinLoading
          }
          variant="outlined"
          type="submit"
          sx={{ mt: 1 }}
        >
          {cabin ? "Update" : "Create"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default CreateUpdateCabin;
